function showLoader() {
    $('#lds-overlay').show();
}
function hideLoader() {
    $('#lds-overlay').hide();
}

function showPaused() {
    $('#lds-paused').show();
}

function hidePaused() {
    $('#lds-paused').hide();
}
